import React, { FunctionComponent } from 'react';

import { AllocationAlert } from './AllocationAlert';

import { LimitTypes } from './customLimitsTypes';
import { assignLimitsUnits } from './helpers/assignLimitsUnits';

import './styles/limits-usage-footer.scss';

interface LimitsUsageFooterProps {
  limit: number;
  limitType: LimitTypes;
  maxPlanLimit: string | number;
  usage: string | number;
}
export const LimitsUsageFooter: FunctionComponent<LimitsUsageFooterProps> = ({
  limit,
  limitType,
  maxPlanLimit,
  usage,
}) => (
  <div className="limits-total-row-wrap" data-testid="limits-total-row-wrap">
    <div className={`limits-total-container ${limitType}`}>
      <span className="current-usage-total">
        {assignLimitsUnits(limitType, usage)}
      </span>
      <div className={`limits-current-limit ${limitType}`}>
        <div className="limits-current-limit-count">
          <span data-testid="current-limit-total" id="current-limit-total">
            {limit.toLocaleString('en-US')}
          </span>
          <span data-testid="max-plan-limit" id='current-limit-available'>
            {assignLimitsUnits(limitType, maxPlanLimit).toLocaleString('en-US')}
          </span>
        </div>
        <AllocationAlert
          limit={limit}
          limitType={limitType}
          location="footer"
          maxPlanLimit={maxPlanLimit}
        />
      </div>
    </div>
  </div>
);
